export default __webpack_public_path__ + "static/media/village.b471798a.svg";